import { Modal, Button, Form, Col } from 'react-bootstrap';
import React from "react";
import { useEffect, useState, useRef } from 'react';

const ReusableModal = (props) => {
    const { size, show, handleClose, handleSubmit, title, children } = props;

    // ryan d - custom popup modal that can be used widley across other forms 
    return (
        <Modal size={size} show={show} onHide={handleClose} className="fpModal flowin" style={{ zIndex: 9999 }}>
            <Modal.Header closeButton style={{ backgroundColor: '#00384B', color: '#fff', borderBottom: 'none' }}>
                <div className="fpModal-title">{title}</div>
            </Modal.Header>
            <div className="fpModal-body">
                <Modal.Body>
                    <Form>
                        {children}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Col md="12" xs="12">
                        <Button type="submit" onClick={handleSubmit} className="btn">
                            {props.submitButtonText}
                        </Button>
                    </Col>
                </Modal.Footer>
            </div>
        </Modal>
    );
};

export default ReusableModal;
